:host {
  display: inline-block;
  /** @prop --foreground-color: Defines the foreground color. */
  --foreground-color: var(--dnn-color-foreground, #000);
  /** @prop --background-color: Defines the background color. */
  --background-color: var(--dnn-color-background, #fff);
  /** @prop --focus-color: Defines the color when the component is focused. */
  --focus-color: var(--dnn-color-primary, #3792ED);
  /** @prop --danger-color: Defines the danger color used for invalid data. */
  --danger-color: var(--dnn-color-danger, #900);
  /** @prop --control-radius: Defines the radius for the control corners. */
  --control-radius: var(--dnn-controls-radius, 3px);
  /** @prop --input-text-align: Allows customizing the text alignment of the input text. */
  --input-text-align: left;
}

dnn-fieldset {
  width: 100%;
}

.inner-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

input {
  border: none;
  outline: none;
  background-color: transparent;
  color: var(--foreground);
  text-align: var(--input-text-align);
  width: 100%;
}

.prefix, .suffix {
  font-size: 0.8em;
}

svg.error {
  fill: red;
  width: 1em;
  height: 1em;
  transform: scale(1.5);
  margin-right: 0.5em;
}

button.show-password {
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
}
button.show-password svg {
  height: 1em;
  width: auto;
  fill: var(--foreground);
  transform: scale(1.5);
}

dnn-fieldset {
  --fieldset-foreground-color: var(--foreground-color);
  --fieldset-background-color: var(--background-color);
  --fieldset-focus-color: var(--focus-color);
  --fieldset-danger-color: var(--danger-color);
  --fieldset-control-radius: var(--control-radius);
}